import React from "react";
import { styled } from "styled-components";
import fipayFonts from "../../theme/index";

interface AccountBalanceInputProps {
  icon?: string;
  currencyTitle?: string;
  amountValue?: number;
  currency?: string;
  label?: string;
  placeholder?: string;
}
const AccountBalanceInput: React.FC<AccountBalanceInputProps> = ({
  icon,
  currencyTitle,
  amountValue,
  currency,
  label,
  placeholder,
}) => {
  const formattedAmount = amountValue?.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return (
    <div>
      <Label>{label}</Label>
      <InputStyle>
        <div>
          <Placeholder>{placeholder}</Placeholder>
          {icon && <Icon src={icon} alt="" />}
          <CurrencyTitle>{currencyTitle}</CurrencyTitle>
        </div>
        <div>
          <Amount>
            {currency}
            {formattedAmount}
          </Amount>
        </div>
      </InputStyle>
    </div>
  );
};

export default AccountBalanceInput;

export const InputStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border: 1px solid #e8eaed;
  border-radius: 15px;
  background-color: #f7f7f7;
  height: 50px;
  position: relative;
  box-sizing: border-box;
`;
export const Icon = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 1%;
`;
export const Label = styled.div`
  display: block;
  margin-bottom: 5px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  letter-spacing: 2%;
`;
export const CurrencyTitle = styled.span`
  padding-left: 1rem;
`;
export const Amount = styled.span`
  color: #0e0e0e;
  font-weight: 700;
  line-height: 24px;
`;
export const Placeholder = styled.div`
  color: #b9b8b8;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.6;
`;
